export type VideoRecorderErrorCode =
  | 'not_supported'
  | 'aborted'
  | 'already_used'
  | 'start_error'
  | 'stop_error'
  | 'no_permission'
  | 'inactive';

export class VideoRecorderError extends Error {
  public code: VideoRecorderErrorCode;

  constructor(code: VideoRecorderErrorCode, message?: string) {
    super(message || code);
    this.code = code;
  }
}
